export const menuItemNames = {
  EAT: "Eat",
  PLAY: "Play",
  SHOP: "Shop",
  TRAVEL: "Travel",
  HOTELS: "Hotels",
  CAR_RENTAL: "Car Rental",
  THEME_PARKS: "Parks & Tickets",
  THINGS_TO_DO: "Things to Do",
  ACTIVITIES: "Activities",
  FLIGHTS: "Flights",
  HOT_DEALS: "Hot Deals",
  GROCERY_COUPONS: "Grocery Coupons",
  EVENTS: "Events",
  CRUISE: "Cruises",
};
